import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">韩漫之家</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                免费韩国漫画下拉式在线阅读平台，提供高清韩国漫画大全资源，让每一位漫迷都能享受沉浸式的阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors">首页</Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-background-400 hover:text-background-200 transition-colors">漫画分类</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-200 transition-colors">恋爱漫画</Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-background-400 hover:text-background-200 transition-colors">动作漫画</Link>
                </li>
                <li>
                  <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-200 transition-colors">奇幻漫画</Link>
                </li>
                <li>
                  <Link to="/category/mystery" className="text-sm text-background-400 hover:text-background-200 transition-colors">悬疑漫画</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span>contact@manhuazhijia.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <span>微信公众号：韩漫之家</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <span>中国 · 北京</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {currentYear} 韩漫之家. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">服务条款</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">DMCA</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}